import { ReactNode } from "react";
import { PaletteWrapper } from "src/contexts/PaletteContext";
import useGatheringStore from "../hooks/useGatheringStore";

const GatheringPaletteWrapper = ({ children }: { children?: ReactNode }) => {
	const palette = useGatheringStore((state) => state.palette);

	return (
		<PaletteWrapper palette={palette} syncBackgroundColor>
			{children}
		</PaletteWrapper>
	);
};
export default GatheringPaletteWrapper;
